/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth_Password_Errors_Password_MismatchInputs */

const nl_auth_password_errors_password_mismatch = /** @type {(inputs: Auth_Password_Errors_Password_MismatchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wachtwoorden komen niet overeen`)
};

/**

* @param {Auth_Password_Errors_Password_MismatchInputs} inputs
* @param {{ locale?: "nl" }} options
* @returns {LocalizedString}
*/
const auth_password_errors_password_mismatch = /** @type {((inputs?: Auth_Password_Errors_Password_MismatchInputs, options?: { locale?: "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_Password_Errors_Password_MismatchInputs, { locale?: "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return nl_auth_password_errors_password_mismatch(inputs)
});
export { auth_password_errors_password_mismatch as "auth.password_errors.password_mismatch" }